import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { SimpleTable } from '../k2/K2Tables';
import { fmtCz, fmtKc } from '../k2/k2utils';
import { fmtQty } from '../k2/itemsUtils';

const priceFmt = new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 2 });

// Generic dialog listing item lines (used for article detail and document detail)
export const LinesDialog = ({ title, subtitle, lines, open, onClose, docsByRid, partnerLabel, testId, showArticle }) => {
  const cols = [
    ...(showArticle ? [
      { key: 'article_code', label: 'Kód', className: 'whitespace-nowrap' },
      { key: 'article_name', label: 'Zboží', className: 'font-medium' },
    ] : [
      { key: 'date', label: 'Datum', render: (r) => fmtCz(r.date), className: 'whitespace-nowrap' },
      { key: 'doc', label: 'Doklad', className: 'font-medium whitespace-nowrap' },
      { key: 'partner', label: partnerLabel, render: (r) => docsByRid?.get(r.doc_rid)?.partner || '—' },
    ]),
    { key: 'warehouse', label: 'Sklad' },
    { key: 'quantity', label: 'Množství', num: true, render: (r) => fmtQty(r.quantity, r.unit) },
    { key: 'up', label: 'Cena / MJ', num: true, render: (r) => (r.quantity ? `${priceFmt.format(r.value / r.quantity)} Kč` : '—'), className: 'text-[#57534E]' },
    { key: 'value', label: 'Hodnota', num: true, render: (r) => fmtKc(r.value), className: 'font-semibold' },
  ];
  const total = lines.reduce((a, x) => a + x.value, 0);
  const sorted = [...lines].sort((a, b) => (showArticle ? Math.abs(b.value) - Math.abs(a.value) : (b.date || '').localeCompare(a.date || '')));
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto" data-testid={testId}>
        <DialogHeader>
          <DialogTitle className="font-['Manrope'] text-[#052E16]" data-testid={`${testId}-title`}>{title}</DialogTitle>
        </DialogHeader>
        {subtitle && <p className="text-sm text-[#57534E]">{subtitle}</p>}
        <div className="text-sm text-[#57534E]" data-testid={`${testId}-total`}>{lines.length} řádků · celkem <span className="font-bold text-[#052E16]">{fmtKc(total)}</span></div>
        <SimpleTable testId={`${testId}-lines`} columns={cols} rows={sorted} rowKey={(r) => r.rid} />
      </DialogContent>
    </Dialog>
  );
};
